import { actionTypes } from "../utils";

export const types = {
  ...actionTypes('UPLOAD_FILE'),
  ...actionTypes('DOWNLOAD_FILE'),
  ...actionTypes('DELETE_FILE'),
  ...actionTypes('SET_OBLIGATION_DOCUMENTS'),
  ...actionTypes('SET_LAW_DOCUMENTS'),
  ...actionTypes('UPDATE_DOCUMENT_PERMISSIONS'),
};